import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import {
  CardContentWrapper,
  CardText,
  IconWrapper,
  PillWrapper,
  StyledCard,
} from './Card.styled';

const getAsElement = (isButton, href) => {
  if (isButton) return 'button';

  if (href) return 'a';

  return 'div';
};

const Card = ({ href, as, icon, title, pill, titleAs, isButton, onClick }) => {
  const content = (
    <StyledCard
      $href={href}
      as={getAsElement(isButton, href)}
      data-testid="card"
      isButton={isButton}
      onClick={onClick}
      {...(isButton ? { type: 'button' } : {})}
    >
      <CardContentWrapper>
        <IconWrapper>{icon}</IconWrapper>
        <CardText customAs={titleAs} data-testid="card-title">
          {title}
        </CardText>
      </CardContentWrapper>
      <PillWrapper data-testid="card-pill">{pill}</PillWrapper>
    </StyledCard>
  );

  return href ? (
    <Link href={href} passHref as={as} legacyBehavior>
      {content}
    </Link>
  ) : (
    content
  );
};

Card.propTypes = {
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
    }),
  ]),
  href: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
    }),
  ]),
  icon: PropTypes.node.isRequired,
  pill: PropTypes.node,
  title: PropTypes.string.isRequired,
  titleAs: PropTypes.string,
  isButton: PropTypes.bool,
  onClick: PropTypes.func,
};

Card.defaultProps = {
  as: undefined,
  href: undefined,
  pill: undefined,
  titleAs: 'h5',
  isButton: false,
  onClick: () => {},
};

export default Card;
